module.exports = __webpack_public_path__ + "img/preview-laptop-DE.bded1705.jpeg";